/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Number of pending requests addressed to the current validator.
 * @export
 * @interface CountDemandesATraiterResponse
 */
export interface CountDemandesATraiterResponse {
    /**
     * 
     * @type {number}
     * @memberof CountDemandesATraiterResponse
     */
    count: number;
}

/**
 * Check if a given object implements the CountDemandesATraiterResponse interface.
 */
export function instanceOfCountDemandesATraiterResponse(value: object): value is CountDemandesATraiterResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function CountDemandesATraiterResponseFromJSON(json: any): CountDemandesATraiterResponse {
    return CountDemandesATraiterResponseFromJSONTyped(json, false);
}

export function CountDemandesATraiterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountDemandesATraiterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function CountDemandesATraiterResponseToJSON(json: any): CountDemandesATraiterResponse {
    return CountDemandesATraiterResponseToJSONTyped(json, false);
}

export function CountDemandesATraiterResponseToJSONTyped(value?: CountDemandesATraiterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

